// extracted by mini-css-extract-plugin
export default {"wrapper":"StatTag_wrapper__XgI6p","grey":"StatTag_grey__0SzLY","green":"StatTag_green__62zn7"};